import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { RegisterOptions } from 'react-hook-form';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';

export interface IInternalIdInputProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export const InternalIdControl: React.FC<IInternalIdInputProps> = ({
  name,
  id,
  rules,
}) => {
  const { errors, control } = useFormContext();

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      inputSize="medium"
      blockWidth
      label={addAsterisk('Internal ID', rules)}
      placeholder="e.g. 12345"
      rules={rules}
    />
  );
};
